var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { IsEnum, IsNotEmpty, IsString, MaxLength } from "class-validator";
export var RequestSupportInputType;
(function (RequestSupportInputType) {
    RequestSupportInputType["REQUEST_A_PROVIDER"] = "REQUEST_A_PROVIDER";
})(RequestSupportInputType || (RequestSupportInputType = {}));
export class RequestSupportForProviderInput {
    constructor() {
        this.type = RequestSupportInputType.REQUEST_A_PROVIDER;
    }
}
__decorate([
    IsEnum(RequestSupportInputType)
], RequestSupportForProviderInput.prototype, "type", void 0);
__decorate([
    IsString(),
    IsNotEmpty()
], RequestSupportForProviderInput.prototype, "patientId", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    MaxLength(200)
], RequestSupportForProviderInput.prototype, "searchQuery", void 0);
